import React, { useState } from "react";
import {
  SafeAreaView,
  ScrollView,
  View,
  Text,
  Image,
  TextInput,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import AppImages from "../../Constants/AppImages";
import useAppNavigation from "../../Routes/useAppNavigation";

/**
 * EditProfile (mobile view) — mirrors the production /EditProfile page.
 * Fields: First Name, Last Name, Email, Date Of Birth, Gender, Nationality,
 * City, Address. Built with plain inputs (no native date/dropdown deps).
 */
const LabeledInput = ({ label, value, onChangeText, placeholder, multiline }) => (
  <View style={styles.inputWrap}>
    <Text style={styles.label}>{label}</Text>
    <TextInput
      value={value}
      onChangeText={onChangeText}
      placeholder={placeholder}
      placeholderTextColor="#ACACAC"
      multiline={multiline}
      style={[styles.input, multiline && { height: 80, textAlignVertical: "top" }]}
    />
  </View>
);

const EditProfile = () => {
  const navigation = useAppNavigation();
  const [form, setForm] = useState({
    firstName: "Mark",
    lastName: "Woods",
    email: "markwoods@gmail.com",
    dob: "17-08-1989",
    gender: "Male",
    nationality: "India",
    city: "Pune",
    address: "100, Vishrantwadi, Kalas, Pune- 411005",
  });
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <SafeAreaView style={styles.safe}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Image source={AppImages.Backbtn} style={styles.backIcon} resizeMode="contain" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Edit Profile</Text>
      </View>

      <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ padding: 20 }}>
        <LabeledInput label="First Name" value={form.firstName} onChangeText={set("firstName")} />
        <LabeledInput label="Last Name" value={form.lastName} onChangeText={set("lastName")} />
        <LabeledInput label="Email" value={form.email} onChangeText={set("email")} />
        <LabeledInput label="Date Of Birth" value={form.dob} onChangeText={set("dob")} placeholder="DD-MM-YYYY" />
        <LabeledInput label="Gender" value={form.gender} onChangeText={set("gender")} />
        <LabeledInput label="Nationality" value={form.nationality} onChangeText={set("nationality")} />
        <LabeledInput label="City" value={form.city} onChangeText={set("city")} />
        <LabeledInput label="Address" value={form.address} onChangeText={set("address")} multiline />

        <View style={styles.actions}>
          <TouchableOpacity style={styles.cancelBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.cancelText}>Cancel</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.updateBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.updateText}>Update</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default EditProfile;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.white },
  header: {
    width: "100%",
    height: 58,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    backgroundColor: AppColors.white,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 6,
  },
  backIcon: { width: 8, height: 15 },
  headerTitle: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    marginLeft: 20,
  },
  inputWrap: { marginBottom: 16 },
  label: {
    color: AppColors.brown1,
    fontSize: 13,
    fontFamily: AppFonts.OverpassMedium,
    marginBottom: 6,
  },
  input: {
    borderWidth: 1,
    borderColor: "#ACACAC",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  actions: { flexDirection: "row", marginTop: 10, marginBottom: 30 },
  cancelBtn: {
    flex: 1,
    borderWidth: 1,
    borderColor: AppColors.brown1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: "center",
    marginRight: 8,
  },
  cancelText: { color: AppColors.brown1, fontSize: 15, fontFamily: AppFonts.OverpassMedium },
  updateBtn: {
    flex: 1,
    backgroundColor: AppColors.brown1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: "center",
    marginLeft: 8,
  },
  updateText: { color: AppColors.white, fontSize: 15, fontFamily: AppFonts.OverpassMedium },
});
